import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { CustomInterceptor } from './services/CustomInterceptor';


import { MasterService } from './services/master/master.service';
import { DataService } from './services/data.service';
import { AccountService } from './services/account/account.service';
import { CustomValidatorService   } from './services/validator/custom-validator.service';
import { ProfileService   } from './services/profile/profile.service';
import { RfqService } from './services/rfq/rfq.service';
import { SupplierService } from './services/supplier/supplier.service';
import { EncryptionService } from './encryption/encryption.service';
import { BuyerService } from './services/buyer/buyer.service';
import { ManufacurerService } from './services/Manufacturer/manufacurer.service';
import { ActionTrackerService } from './services/action-tracker/action-tracker.service';
import { CompanyWidgetConfigService } from './services/company-widget-config/company-widget-config.service';
import { MixpanelService } from './services/mixpanel/mixpanel.service';
@NgModule({
  imports: [CommonModule, RouterModule, HttpClientModule, HttpModule],
  exports: [RouterModule, HttpClientModule],
  declarations: [],
  providers: [DataService , ManufacurerService, AccountService, CustomValidatorService,
    BuyerService, ProfileService, MasterService, SupplierService,ActionTrackerService,
    EncryptionService, RfqService, CompanyWidgetConfigService, MixpanelService,
     { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor,
      multi: true }
  ] // these should be singleton
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts